import test from './modules/test';
import goodsService from './modules/goods-service';
import operations from './modules/operations';
import systemConfig from './modules/system-config';
import jianpaiScm from './modules/jianpai-scm';
import messageCenter from './modules/message-center';
import productionDemand from './modules/production-demand';
import projectService from './modules/project-service';
import ssoCenter from './modules/sso-center';
import monitorCenter from './modules/monitor-center';
import domainSystem from './modules/domain-system';
import contentManage from './modules/content-manage';

export default [
  ...test,
  ...goodsService,
  ...operations,
  ...systemConfig,
  ...jianpaiScm,
  ...messageCenter,
  ...productionDemand,
  ...projectService,
  ...ssoCenter,
  ...monitorCenter,
  ...domainSystem,
  ...contentManage,
];
